import { render, staticRenderFns } from "./CustomTablesList.vue?vue&type=template&id=3d4fe924&scoped=true"
import script from "./CustomTablesList.vue?vue&type=script&lang=js"
export * from "./CustomTablesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4fe924",
  null
  
)

export default component.exports